/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import DataTable from 'react-data-table-component';
import TableSkeleton from '/client/src/components/skeletons/dataTableSkeleton';


type PropsType = {
  tableTab?: string,
  counter: number,
  data: [],
  editRow: {} | null,
  toggleEdit: (number) => void,
  progressPending: boolean,
  maxResultCount: number,
  setMaxResultCount: (number) => void,
  setSendData: ({}) => void,
  totalRows: number,
  handlePageChange: (number) => void,
  handleSort: (string) => void,
  currentPage: number,
  onHandleFindAndReplaceRowData: () => void
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  },
  tableWrapper: {
    style: {
      display: 'block',
      overflowX: 'scroll'
    }
  },
  table: {
    style: {
      display: 'table'
    }
  }
};

let mock = {
  columns: []
};

const EventPageDetailResendBody = ({
  tableTab,
  counter,
  data,
  editRow,
  toggleEdit,
  progressPending,
  setSendData,
  onHandleFindAndReplaceRowData,
  maxResultCount,
  setMaxResultCount,
  totalRows,
  handlePageChange,
  handleSort,
  currentPage
}: PropsType): React.Element<'div'> => {
  try {
    mock = require(`./tableHeaders/${_.toString(tableTab) === '' ? 'tickets.js' : `${_.toString(tableTab)}.js`}`);
  } catch (e) {
    console.warn(`File "./tableHeaders/${_.toString(tableTab)}" doesn't exist`);
  }

  const __data = data;

  return (
    <div className="panel-body" data-reload={counter}>
      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <DataTable
            className={
              _.toString(tableTab) === '' || tableTab === 'tickets' ?
                'EventPageDetailResend-Tickets' :
                'EventPageDetailResend'}
            columns={mock.columns(editRow, toggleEdit, onHandleFindAndReplaceRowData)}
            data={__data}
            customStyles={customStyles}
            sortServer
            onSort={(column, sortDirection) => handleSort(`${column.selector === 'creation_time' ? 'order.' : ''}${column.selector}+${sortDirection}`)}
            defaultSortField="first_name"
            selectableRows
            selectableRowsHighlight
            onSelectedRowsChange={(_data: any) => {
              setSendData(_data);
            }}
            highlightOnHover
            clearSelectedRows={progressPending}
            pointerOnHover
            responsive
            striped
            fixedHeader
            noHeader
            pagination
            paginationPerPage={maxResultCount}
            paginationServer
            paginationTotalRows={totalRows}
            paginationDefaultPage={currentPage}
            paginationRowsPerPageOptions={[100, 500, 1000]}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={setMaxResultCount}
            persistTableHead
            progressPending={progressPending}
            progressComponent={<TableSkeleton rows={maxResultCount} columns={mock.columns(editRow, toggleEdit, onHandleFindAndReplaceRowData)} />}
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EventPageDetailResendBody;
